import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { useDispatch } from "Hooks/useDispatch";
import useI18n from "Hooks/UseI18n";
import {
  getMessagingV2ReduxState,
  goToMessagingV2FormRoute,
  setIniFormSubmittedModal,
} from "MessagingV2/modules/MessagingModule";
import { isIdEqual } from "Utils/idHelpers";
import { Dialog } from "@toddle-edu/ds-web";

const InitFormRespondedModal = props => {
  const { chatId, initFormRespondedModal } = props;
  const dispatch = useDispatch();
  const { t } = useI18n(["common"]);

  const onCloseModal = React.useCallback(() => {
    dispatch(setIniFormSubmittedModal({ chatId: null, formId: null }));
  }, [dispatch]);

  const onFormOpen = () => {
    const formId = _.get(initFormRespondedModal, "formId");
    const messageId = _.get(initFormRespondedModal, "messageId");
    if (!formId) return;
    onCloseModal();
    dispatch(
      goToMessagingV2FormRoute({
        chatId,
        formId,
        ...(messageId ? { messageId } : {}),
      })
    );
  };

  const showModal = isIdEqual(chatId, initFormRespondedModal?.chatId);

  return showModal ? (
    <Dialog
      dsVersion="2.0"
      variant="confirm-dialog"
      title={t("common:response_recorded")}
      message={t("common:response_recorded_subtext")}
      buttonOneText={t("common:cancel")}
      buttonTwoText={t("common:view_response")}
      onButtonOneClick={onCloseModal}
      onButtonTwoClick={onFormOpen}
      onClose={onCloseModal}
    />
  ) : null;
};

const mapStateToProps = state => {
  const messagingState = getMessagingV2ReduxState(state);

  const initFormRespondedModal = _.get(
    messagingState,
    "initFormRespondedModal"
  );
  return {
    initFormRespondedModal,
  };
};

export default connect(mapStateToProps)(InitFormRespondedModal);
